import React, { memo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { map, filter, includes } from 'lodash';
import RouteWithSubRoutesContainer from '../../../app/containers/RouteWithSubRoutesContainer';
import PageNotFound from '../../../shared/components/PageNotFound/PageNotFound';
import HeaderContainer from '../../containers/HeaderContainer';
import SideBarContainer from '../../containers/SideBarContainer';
import styles from './home.module.scss';

export default memo(function Home(props) {
    const forbiddenRoutesIfNotOnNano = ['QUICK_SETUP'];
    const routes = props.isNano
        ? props.routes
        : filter(props.routes, route => !includes(forbiddenRoutesIfNotOnNano, route.title));

    return (
        <div className={styles.homeContainer}>
            <SideBarContainer />
            <div className={styles.mainContainer}>
                <HeaderContainer />
                <div className={styles.contentContainer}>
                    <Switch>
                        {map(routes, route => <RouteWithSubRoutesContainer key={route.path} {...route} />)}
                        <Route component={PageNotFound} />
                    </Switch>
                </div>
            </div>
        </div>
    );
});
